import React, { useEffect, useRef, useState } from "react"
import { compose } from "redux"
import { Divider, Popover, Spin, Tooltip } from "antd"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectIsLoading, makeSelectDivisionsRate } from "./selectors"
import { getDataDivisionsRateWatcher } from "./actions"

import "./index.less"

import { get } from "lodash"
import ProgressBar from "../../../../../components/ProgressBar"
import { isModuleBySlug } from "../../../../../utils/storage"
import { HISTORICAL_ANALYSIS, MEASURE_STATUS } from "../../../../../utils/constants"
import { validate } from "../../../../../utils/functions"
import { ArrowDownIcon } from "../../../../../icons/svg/iconArrowDown"
import { ArrowUpIcon } from "../../../../../icons/svg/iconArrowUp"
import { loadTexts } from "../../../../../utils/i18n"
import { QuestionCircleFilled } from "@ant-design/icons"

function usePreviousMeasureID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

function usePreviousDivisionID(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}
export function WidgetResponseRateReport(props) {
  const intlWidgetResponseRate = loadTexts("reports_general_view")
    .reportAmbassador.engagementMeasurement.widgetResponseRateReport
  const [measureID] = useState(props.idMeasure)
  const [divisionID] = useState(props.idDivisionSelected)
  const prevMeasureID = usePreviousMeasureID(measureID)
  const prevDivisionID = usePreviousDivisionID(divisionID)

  useEffect(() => {
    if (prevMeasureID !== measureID) {
      initGetData()
    } else {
      if (prevDivisionID !== divisionID) {
        initGetData()
      }
    }
  }, [props.idMeasure, props.idDivisionSelected])

  const initGetData = async () => {
    const {
      idMeasure,
      getDataDivisionsRate,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props
    getDataDivisionsRate({
      isHome: true,
      id_measure: idMeasure,
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    })
  }

  const renderComparative = () => {
    const { measureData, measureGeneral} = props
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)

    if (
      !validate.exist(measureData) ||
      !validate.exist(measureData.rate_variation) ||
      !measureData.rate_variation.show ||
      !isHistoricalAnalysis ||
      get(measureGeneral, 'id_measure_type', 1) === 2
    ) {
      return null
    }
    return (
      <div className="WidgetResponseRateReport-body-comparative">
        <div className="WidgetResponseRateReport-body-comparative-title">
          {intlWidgetResponseRate.previousMeasure}
        </div>
        <div className="WidgetResponseRateReport-body-comparative-content">
          <div className="WidgetResponseRateReport-body-comparative-content-value">
            {`${measureData.rate_variation.prev_value}%`}
          </div>
          <div
            className={`WidgetResponseRateReport-body-comparative-content-compare ${
              measureData.rate_variation.level === true
                ? " green"
                : measureData.rate_variation.level === false
                ? " red"
                : ""
            }
            `}>
            <div>{`${measureData.rate_variation.value_rate}%`}</div>
            {measureData.rate_variation.level === true ? (
              <ArrowUpIcon style={{ marginLeft: 2 }} />
            ) : measureData.rate_variation.level === false ? (
              <ArrowDownIcon style={{ marginLeft: 2 }} />
            ) : null}
          </div>
        </div>
      </div>
    )
  }

  const renderProgress = () => {
    const { measureData } = props
    return (
      <div className="WidgetResponseRateReport-body-progress">
        <ProgressBar
          custom={{
            color: get(measureData, "rate.rate_color", "red"),
            value: get(measureData, "rate.rate", 0),
          }}
        />
      </div>
    )
  }

  const renderPercent = () => {
    const { measureData } = props
    return (
      <div
        className="WidgetResponseRateReport-body-percent"
        style={{ color: get(measureData, "rate.rate_color", "black") }}>
        <span className="WidgetResponseRateReport-body-percent-value">
          {get(measureData, "rate.rate_visible", 0)}
        </span>
        <span className="color-gray-low">
          {get(measureData, "employees", 0)}/{get(measureData, "recipients", 0)}
          {intlWidgetResponseRate.collaborators}
        </span>
      </div>
    )
  }

  const renderListDivisions = () => {
    const { divisionsRate } = props
    if (
      !validate.exist(divisionsRate) ||
      !validate.exist(divisionsRate.division_rate_top) ||
      !validate.exist(divisionsRate.division_rate_bottom)
    ) {
      return null
    }
    return (
      <div className="WidgetResponseRateReport-body-division">
        <div className="WidgetResponseRateReport-body-division-top">
          <div className="WidgetResponseRateReport-body-division-top-title">
            <Tooltip title="Mayor tasa de respuesta" placement="top">
              <div className="circle" />
            </Tooltip>
            <div className="cropText">
              {divisionsRate.division_rate_top.division_name}
            </div>
          </div>
          <div className="WidgetResponseRateReport-body-division-top-value">
            {`${divisionsRate.division_rate_top.rate}%`}
          </div>
        </div>
        <div className="WidgetResponseRateReport-body-division-bottom">
          <div className="WidgetResponseRateReport-body-division-bottom-title">
            <Tooltip title="Menor tasa de respuesta" placement="bottom">
              <div className="circle" />
            </Tooltip>
            <div className="cropText">
              {divisionsRate.division_rate_bottom.division_name}
            </div>
          </div>
          <div className="WidgetResponseRateReport-body-division-bottom-value">
            {`${divisionsRate.division_rate_bottom.rate}%`}
          </div>
        </div>
      </div>
    )
  }

  const renderContent = () => {
    const { isLoading } = props
    if (isLoading) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }
    return (
      <div className="WidgetResponseRateReport-body">
        {renderPercent()}
        {renderProgress()}
        {renderComparative()}
        <Divider className="WidgetResponseRateReport-body-divider" />
        {renderListDivisions()}
      </div>
    )
  }

  if (props.isLoading) {
    return (
      <div className="WidgetResponseRateReport boxShadow">
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      </div>
    )
  }

  return (
    <div className="WidgetResponseRateReport boxShadow">
      <div className="WidgetResponseRateReport-title">
        {intlWidgetResponseRate.title}
        {(props.measureGeneral.id_measure_status === MEASURE_STATUS.in_progress.id_measure_status
        ) && <Popover content={() => {
          return (
            <span>
              Este indicador es actualizado <br/> cada <b>12 horas</b>, según los <br/> colaboradores vayan <br/>contestando la encuesta y se <br/> reprocesen sus respuestas.
            </span>
          )
        }}>
          <QuestionCircleFilled style={{color: "#A7A3A3"}}/>
        </Popover>}
      </div>
      {renderContent()}
    </div>
  )
}

WidgetResponseRateReport.propTypes = {
  isLoading: PropTypes.bool,
  measureData: PropTypes.object,
  measureGeneral: PropTypes.object,
  divisionsRate: PropTypes.object,
  idMeasure: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  getDataDivisionsRate: PropTypes.func,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  divisionsRate: makeSelectDivisionsRate(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDataDivisionsRate: (params) =>
      dispatch(getDataDivisionsRateWatcher(params)),
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({ key: "widgetResponseRateReport", reducer })
const withSaga = injectSaga({ key: "widgetResponseRateReport", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResponseRateReport)
